<template>
  <div class="padding-10px" v-loading="loading">
    <el-card class="box-card" shadow="none" style="min-height: 500px;">
      <div slot="header" class="clearfix" style="display: flex; flex-direction: column">
        <el-row>
          <el-col :lg="2" :md="2" :span="2">
            <el-select v-model="searchStatusSelect" @change="searchStatusSelectChange" size="medium" placeholder="状态"
              style="width: 90%;" clearable>
              <el-option label="全部" value="-1" key="-1"></el-option>
              <el-option v-for="s in dialogStatus" :label="s.label" :value="s.value" :key="s.value" />
            </el-select>
          </el-col>
          <el-col :lg="3" :md="3" :span="3">
            <el-select v-model="searchWhetherGuideSelect" @change="searchWhetherGuideSelectChange" value="是"
              size="medium" placeholder="是否导购" style="width: 93%" clearable>
              <el-option label="全部" value="-1" key="-1" />
              <el-option label="是" value="1" key="1"></el-option>
              <el-option label="否" value="0" key="0"></el-option>
            </el-select>
          </el-col>
          <el-col :lg="2" :md="2" :span="2">
            <el-select placeholder="渠道" clearable size="medium" v-model="searchChannelSelect"
              @change="searchChannelSelectChange" @focus="searchGetChannel" style="width: 90%;">
              <el-option label="全部" value="-1" key="-1" />
              <el-option v-for="channel in searchChannels" :value="channel.channelId" :key="channel.channelId"
                :label="channel.channelName" />
            </el-select>
          </el-col>
          <el-col :lg="6" :md="6" :span="6">
            <el-date-picker v-model="createTime" style="width: 97%" align="center" type="daterange" size="medium"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-col>
          <el-col :lg="4" :md="3" :span="5">
            <el-input size="medium" placeholder="姓名、手机、业务员" v-model="key" clearable style="width: 95%;"></el-input>
          </el-col>
          <el-col :lg="2" :md="2" :span="2">
            <el-button size="medium" type="primary" @click="searchCarLoan" icon="el-icon-search">搜索</el-button>
          </el-col>
          <el-col :md="2" :lg="2" :span="2">
            <el-button @click="exportCarLoan" type="success" size="medium"
              v-if="checkButtonPermission('carload:manage:export')">导出</el-button>
          </el-col>
          <el-col :lg="3" :md="4" :span="2">
            &nbsp;
            <el-button size="medium" type="success" @click="openDialog('add', null)"
              v-if="checkButtonPermission('carload:manage:add')">新增车贷</el-button>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-table :data="tableData" ref="multipleTable" tooltip-effect="dark" border fixed style="width: 100%"
          @selection-change="handleSelectionChange">
          <!-- <el-table-column min-width="40" type="selection"/> -->
          <el-table-column label="序号" align="center" width="60">
            <template slot-scope="scope"><span>{{ scope.$index + (currentPage - 1) * pageSize + 1 }} </span></template>
          </el-table-column>
          <el-table-column prop="name" label="姓名" min-width="70" />
          <el-table-column prop="telephone" label="电话" min-width="110" />
          <el-table-column prop="salesmanId" label="业务员" min-width="70">
            <template slot-scope="scope" v-if="null != scope.row.userInfo">
              <span v-if="scope.row.userInfo.realName != null && scope.row.userInfo.realName != ''"
                v-text="scope.row.userInfo.realName"></span>
              <span v-else-if="scope.row.userInfo.realName == null || scope.row.userInfo.realName == ''"
                v-text="scope.row.userInfo.wechatNickName"> </span>
            </template>
          </el-table-column>
          <el-table-column prop="salesmanId" label="业务员电话" min-width="110">
            <template slot-scope="scope" v-if="null != scope.row.userInfo">
              <span v-text="scope.row.userInfo.telephone"></span>
            </template>
          </el-table-column>
          <el-table-column prop="channel.channelName" label="渠道" min-width="120" />

          <el-table-column prop="salesmanId" label="区域" min-width="70">
            <template slot-scope="scope" v-if="null != scope.row.userInfo">
              <span v-text="scope.row.userInfo.regionalSubBranch"></span>
            </template>
          </el-table-column>
          <el-table-column prop="salesmanId" label="网点" min-width="70">
            <template slot-scope="scope" v-if="null != scope.row.userInfo">
              <span v-text="scope.row.userInfo.companyName"></span>
            </template>
          </el-table-column>

          <el-table-column prop="loanAmount" label="汽车类型" min-width="80">
            <template slot-scope="scope">
              <span v-if="(scope.row.remark || '').indexOf('二手车') !== -1">二手车</span>
              <span v-else-if="(scope.row.remark || '').indexOf('燃油车') !== -1">燃油车</span>
              <span v-else-if="(scope.row.remark || '').indexOf('新能源') !== -1">新能源</span>
              <span v-else>新车</span>
            </template>
          </el-table-column>
          <el-table-column prop="whetherGuide" label="是否导购" min-width="50">
            <template slot-scope="scope">
              <span v-if="scope.row.whetherGuide == 1">是</span>
              <span v-else-if="scope.row.whetherGuide == 0">否</span>
            </template>
          </el-table-column>
          <el-table-column prop="carBrandName" label="品牌" min-width="50" />
          <el-table-column prop="carCategoryName" label="车型" min-width="50" />
          <el-table-column prop="createTime" label="时间" min-width="160" />
          <el-table-column prop="status" label="状态" min-width="70">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0">待回访</span>
              <span v-else-if="scope.row.status == 1">已回访</span>
              <span v-else-if="scope.row.status == 2">已取消</span>
              <span v-else-if="scope.row.status == 3">待受理</span>
              <span v-else-if="scope.row.status == 4">已受理</span>
              <span v-else-if="scope.row.status == 5">审核通过</span>
              <span v-else-if="scope.row.status == 6">审核不通过</span>
              <span v-else-if="scope.row.status == 7">待提放</span>
              <span v-else-if="scope.row.status == 8">已提放</span>
              <span v-else-if="scope.row.status == 9">已放款</span>
              <span v-else-if="scope.row.status == 10">已完成</span>
            </template>
          </el-table-column>

          <el-table-column prop="saleRemark" label="后台备注" width="280">
            <template slot-scope="scope" v-if="undefined != scope.row.saleRemark && '' != scope.row.saleRemark">
              <!-- <el-tooltip class="item span_hover" effect="light" :content="scope.row.saleRemark" placement="top">
                <span class="span_hide saleRemark" v-html="scope.row.saleRemark" />
              </el-tooltip> -->
              <span v-text="scope.row.saleRemark" />
            </template>
          </el-table-column>

          <el-table-column label="操作" min-width="220" fixed="right">
            <template slot-scope="scope">
              <el-button @click="openDialog('edit', scope.row)" type="success" size="mini"
                v-if="checkButtonPermission('carload:manage:edit')">编辑
              </el-button>
              <el-button @click="openDialog('info', scope.row)" type="info"
                style="background-color: #7266ba; border-color: #7266ba;" size="mini"
                v-if="checkButtonPermission('carload:manage:detail')">详情</el-button>
              <el-button type="danger" @click="deleteCarLoan(scope.row.carLoanId)" size="mini"
                v-if="checkButtonPermission('carload:manage:delete')">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin: 18px 0px; float: right;">
          <el-pagination background @current-change="currentPageChange" @size-change="pageSizeChange"
            :current-page="currentPage" :page-sizes="[5, 10, 20, 50, 100]" :page-size="pageSize" :page-count="totalPage"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </el-card>
    <el-dialog :visible.sync="dialogVisible" @closed="resetForm('carLoanForm')" :title="dialogTitle + '车贷单'"
      :modal="false" :close-on-click-modal="false">
      <el-form :model="carLoanForm" ref="carLoanForm" :rules="carLoanFormRules" label-width="120px" size="medium"
        style="padding: 0 10%;">
        <el-form-item label="姓名" prop="name">
          <el-input v-if="dialogType != 'info'" clearable v-model="carLoanForm.name"></el-input>
          <span v-else-if="dialogType == 'info'" v-text="carLoanForm.name"></span>
        </el-form-item>
        <el-form-item label="电话" prop="telephone">
          <el-input v-if="dialogType != 'info'" clearable v-model="carLoanForm.telephone"></el-input>
          <span v-else-if="dialogType == 'info'" v-text="carLoanForm.telephone"></span>
        </el-form-item>
        <el-form-item label="渠道" prop="channelId">
          <el-select v-if="dialogType != 'info'" placeholder="请选择渠道" v-model="dialogChannelSelect"
            @change="dialogChannelChange" size="medium">
            <el-option v-for="channel in dialogChannels" :value="channel.channelId" :key="channel.channelId"
              :label="channel.channelName"></el-option>
          </el-select>
          <span v-else-if="dialogType == 'info'" v-text="carLoanForm.channel.channelName"></span>
        </el-form-item>
        <el-form-item label="业务员" prop="salesmanId">
          <!-- <el-input v-if="dialogType == 'info'" clearable v-model="carLoanForm.salesmanId"></el-input> -->
          <span v-if="carLoanForm.userInfo != null" v-text="carLoanForm.userInfo.realName"></span>
        </el-form-item>
        <el-form-item label="业务员电话" prop="salesmanId">
          <!-- <el-input v-if="dialogType == 'info'" clearable v-model="carLoanForm.salesmanId"></el-input> -->
          <span v-if="carLoanForm.userInfo != null" v-text="carLoanForm.userInfo.telephone"></span>
        </el-form-item>
        <el-form-item v-if="dialogType == 'edit'" label="分期编号" prop="installmentNo">
          <el-input clearable v-model="carLoanForm.installmentNo"></el-input>
        </el-form-item>
        <el-form-item label="贷款金额" prop="loanAmount">
          <el-input v-if="dialogType != 'info'" clearable v-model="carLoanForm.loanAmount"></el-input>
          <span v-else-if="dialogType == 'info'" v-text="carLoanForm.loanAmount"></span>
        </el-form-item>
        <el-form-item label="是否导购" prop="whetherGuide">
          <el-select @change="dialogWhetherGuideSelectChange" v-model="dialogWhetherGuideSelect"
            v-if="dialogType != 'info'">
            <el-option v-for="wetherLoan in dialogWhetherGuides" :label="wetherLoan.label" :value="wetherLoan.value"
              :key="wetherLoan.value">
            </el-option>
          </el-select>
          <span v-else-if="dialogType == 'info'">
            <span v-if="carLoanForm.whetherGuide == 1">是</span>
            <span v-else-if="carLoanForm.whetherGuide == 0">否</span>
          </span>
        </el-form-item>
        <el-form-item label="客户备注" prop="remark">
          <span v-text="carLoanForm.remark"></span>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select @change="dialogStatusSelectChange" v-model="dialogStatusSelect" v-if="dialogType != 'info'">
            <el-option v-for="s in dialogStatus" :label="s.label" :value="s.value" :key="s.value">
            </el-option>
          </el-select>
          <span v-else-if="dialogType == 'info'">
            <span v-if="carLoanForm.status == 0">待回访</span>
            <span v-else-if="carLoanForm.status == 1">已回访</span>
            <span v-else-if="carLoanForm.status == 2">已取消</span>
            <span v-else-if="carLoanForm.status == 3">待受理</span>
            <span v-else-if="carLoanForm.status == 4">已受理</span>
            <span v-else-if="carLoanForm.status == 5">审核通过</span>
            <span v-else-if="carLoanForm.status == 6">审核不通过</span>
            <span v-else-if="carLoanForm.status == 7">待提放</span>
            <span v-else-if="carLoanForm.status == 8">已提放</span>
            <span v-else-if="carLoanForm.status == 9">已放款</span>
            <span v-else-if="carLoanForm.status == 10">已完成</span>
          </span>
        </el-form-item>
        <el-form-item label="后台备注" prop="saleRemark">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入内容"
            v-model="carLoanForm.saleRemark" v-if="dialogType != 'info'">
          </el-input>
          <span v-else-if="dialogType == 'info'" v-text="carLoanForm.saleRemark"></span>
        </el-form-item>
        <el-form-item size="large">
          <span>
            <el-button @click="dialogVisible = false">&nbsp;&nbsp;&nbsp;取&nbsp;&nbsp;消&nbsp;&nbsp;&nbsp;</el-button>
            <el-button type="primary"
              @click="dialogSubmit('carLoanForm')">&nbsp;&nbsp;&nbsp;确&nbsp;&nbsp;定&nbsp;&nbsp;&nbsp;</el-button>
          </span>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--<el-dialog :visible.sync="uploadDialogVisible">
      <img width="100%" :src="userForm.carCategoryImage" alt="">
    </el-dialog>-->
  </div>
</template>

<script>
export default {
  name: "carLoanList",
  data() {
    return {
      loading: false,
      key: '',
      multipleTable: [],
      multipleSelection: [],
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      totalPage: 100,
      total: 100000,
      createTime: [],
      searchChannels: [],
      searchStatusSelect: '',
      searchChannelSelect: '',
      searchChannelSelectVal: '',
      searchStatusSelectVal: '',
      searchWhetherGuideSelect: '',
      searchWhetherGuideSelectVal: '',
      dialogType: 'add',
      dialogTitle: '新增',
      dialogVisible: false,
      carLoanForm: {
        userInfo: {
          realName: ''
        }
      },
      carLoanFormRules: {},
      dialogChannels: [],
      dialogChannelSelect: '',
      dialogChannelSelectVal: '',
      dialogWhetherGuideSelect: '',
      dialogWhetherGuideSelectVal: '',
      dialogWhetherGuides: [
        {
          label: '是',
          value: 1,
        },
        {
          label: '否',
          value: 0,
        },
      ],
      dialogStatus: [
        {
          label: '待回访',
          value: 0
        },
        {
          label: '已回访',
          value: 1
        },
        {
          label: '已取消',
          value: 2
        },
        {
          label: '待受理',
          value: 3
        },
        {
          label: '已受理',
          value: 4
        },
        {
          label: '审核通过',
          value: 5
        },
        {
          label: '审核不通过',
          value: 6
        },
        {
          label: '待提放',
          value: 7
        },
        {
          label: '已提放',
          value: 8
        },
        {
          label: '已放款',
          value: 9
        },
        {
          label: '已完成',
          value: 10
        },
      ],
      dialogStatusSelect: 0,
      carBrandName: '',
      carCategoryName: '',
    }
  },
  created() {
    this.searchCarLoan();
  },
  methods: {
    exportCarLoan() {
      this.loading = true
      // let carLoanIds = [];
      // this.tableData.forEach(carLoan => {
      //     carLoanIds.push(carLoan.carLoanId);
      // });
      let reqParam = {
        key: this.key,
        size: this.pageSize,
        currentPage: this.currentPage,
      };
      if (this.searchChannelSelectVal != -1) {
        reqParam.channelId = this.searchChannelSelectVal;
      }
      if (this.searchWhetherGuideSelectVal != -1) {
        reqParam.whetherGuide = this.searchWhetherGuideSelectVal;
      }
      if (null === this.createTime || undefined === this.createTime) {
        reqParam.startCreateTime = null;
        reqParam.endCreateTime = null;
      }
      else {
        reqParam.startCreateTime = this.createTime[0];
        reqParam.endCreateTime = this.createTime[1];
      }
      if (this.searchStatusSelectVal != -1) {
        reqParam.status = this.searchStatusSelectVal;
      }

      this.$http({
        url: '/api/advance-order-service/carloan/export',
        method: 'post',
        responseType: 'blob',
        data: reqParam,
        timeout: 600000,
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(res => {
        this.loading = false;
        let blob = new Blob([res.data], { type: res.headers['content-type'] });
        let downloadElement = document.createElement('a');
        let href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = '车贷单.xlsx'; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
      }).catch(e => {

      })
    },
    searchChannelSelectChange(val) {
      this.searchChannelSelectVal = val;
    },
    searchWhetherGuideSelectChange(val) {
      this.searchWhetherGuideSelectVal = val;
    },
    searchStatusSelectChange(val) {
      this.searchStatusSelectVal = val;
      // multipleTable: []
      // multipleSelection
      console.log(this.multipleTable);
    },
    searchGetChannel() {
      this.$http.post('/api/channel-service/channel/logged/all', {}, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        let data = resp.data;
        console.log(data)
        if (data.code === "success") {
          let channels = new Array();
          /*let allChannel = {
            label: '全部',
            value: ''
          };
          channels.push(allChannel);
          // data.resultList
          data.resultList.forEach(list => {
            channels.push(list);
          });*/
          console.log(data.resultList);
          this.searchChannels = data.resultList;
        }
      }).catch(e => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + e, '错误提示', {
          confirmButtonText: '确定'
        });
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    searchCarLoan() {
      let reqParam = {
        key: this.key,
        size: this.pageSize,
        currentPage: this.currentPage,
      };
      if (this.searchChannelSelectVal != -1) {
        reqParam.channelId = this.searchChannelSelectVal;
      }
      if (this.searchWhetherGuideSelectVal != -1) {
        reqParam.whetherGuide = this.searchWhetherGuideSelectVal;
      }
      if (null === this.createTime || undefined === this.createTime) {
        reqParam.startCreateTime = null;
        reqParam.endCreateTime = null;
      }
      else {
        reqParam.startCreateTime = this.createTime[0];
        reqParam.endCreateTime = this.createTime[1];
      }
      if (this.searchStatusSelectVal != -1) {
        reqParam.status = this.searchStatusSelectVal;
      }
      this.$http.post('/api/advance-order-service/logged/carloan/search', reqParam, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        console.log(resp);
        let pageInfo = resp.data.pageInfo;
        this.tableData = pageInfo.list;
        this.pageSize = pageInfo.pageSize;
        this.total = pageInfo.total;
        this.totalPage = pageInfo.pages;
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      })
    },
    addCarLoan(formName, reqParam) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http.post('/api/advance-order-service/carloan/add', reqParam, {
            headers: {
              accessToken: sessionStorage.getItem('accessToken')
            }
          }).then(resp => {
            if (resp.data.code === "success" || resp.data.code === "0") {
              this.searchCarLoan();
              this.$message({
                message: '新增导购单成功',
                type: 'success'
              });
              this.dialogVisible = false;
              this.resetForm('carLoanForm');
            } else {
              this.$alert(resp.data.message || '', '温馨提示', {
                confirmButtonText: '确定'
              });
            }
          }).catch(e => {
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    editCarLoan(formName, reqParam) {
      this.$http.post('/api/advance-order-service/carloan/update', reqParam, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        let data = resp.data;
        if (data.code === "success") {
          this.$message({
            message: '编辑导购单成功',
            type: 'success'
          });
          this.dialogVisible = false;
          this.searchCarLoan();
        } else {
          this.$alert('' + data.message, '温馨提示', {
            confirmButtonText: '确定'
          });
        }
      }).catch(e => {

      })
    },
    deleteCarLoan(carLoanId) {
      this.$confirm('此操作将永久删除该车贷单, 是否继续?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/api/advance-order-service/carloan/delete?carLoanId=' + carLoanId, {}, {
          headers: {
            accessToken: sessionStorage.getItem('accessToken')
          }
        }).then(resp => {
          let data = resp.data;
          if (data.code === "success") {
            this.$message({
              message: '删除车贷单成功',
              type: 'success'
            });
            this.searchCarLoan();
          } else {
            this.$alert('' + data.message, '温馨提示', {
              confirmButtonText: '确定'
            });
          }
        }).catch(e => {

        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    currentPageChange(val) {
      this.currentPage = val;
      this.searchCarLoan();
    },
    pageSizeChange(val) {
      this.pageSize = val;
      this.searchCarLoan();
    },
    dialogGetChannels() {
      this.$http.post('/api/channel-service/channel/logged/all', {}, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        let data = resp.data;
        console.log(data)
        if (data.code === "success") {
          this.dialogChannels = data.resultList;
        }
      }).catch(e => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + e, '错误提示', {
          confirmButtonText: '确定'
        });
      })
    },
    dialogChannelChange(val) {
      this.dialogChannelSelectVal = val;
    },
    dialogWhetherGuideSelectChange(val) {
      this.dialogWhetherGuideSelectVal = val;
    },
    dialogStatusSelectChange(val) {
    },
    openDialog(dialogType, data) {
      if ('add' === dialogType) {
        this.dialogType = 'add';
        this.dialogTitle = '新增';
        this.dialogGetChannels();
      }
      else if ('edit' === dialogType) {

        // 1.初始化数据
        this.dialogType = 'edit';
        this.dialogTitle = '编辑';
        this.dialogGetChannels();

        // 2.绑定数据下拉框
        // 渠道
        this.dialogChannelSelect = data.channel.channelName;
        this.dialogChannelSelectVal = data.channelId;

        // 绑定是否导购
        this.dialogWhetherGuideSelectVal = data.whetherGuide;
        if (data.whetherGuide == 1) {
          this.dialogWhetherGuideSelect = '是';
        } else if (data.whetherGuide == 0) {
          this.dialogWhetherGuideSelect = '否';
        }

        // 状态
        this.dialogStatusSelect = data.status;

        let tmp = {};
        Object.assign(tmp, data);
        console.log(tmp);
        this.carLoanForm = tmp;
        console.log("carloan data is " + JSON.stringify(tmp));
      }
      else if ('info' === dialogType) {
        this.dialogType = 'info';
        this.dialogTitle = '查看';
        let tmp = {};
        Object.assign(tmp, data);
        console.log(tmp);
        this.carLoanForm = tmp;
      }
      this.dialogVisible = true;
    },
    dialogSubmit(formName) {
      let reqParam = {
        name: this.carLoanForm.name,
        telephone: this.carLoanForm.telephone,
        salesmanId: this.carLoanForm.salesmanId,
        channelId: this.dialogChannelSelectVal,
        loanAmount: this.carLoanForm.loanAmount,
        whetherGuide: this.dialogWhetherGuideSelectVal,
        remark: this.carLoanForm.remark,
        status: this.dialogStatusSelect,
        installmentNo: this.carLoanForm.installmentNo,
        saleRemark: this.carLoanForm.saleRemark
      };

      if ('add' === this.dialogType) {
        this.addCarLoan(formName, reqParam);
      }
      else if ('edit' === this.dialogType) {
        reqParam.carLoanId = this.carLoanForm.carLoanId;
        this.editCarLoan(formName, reqParam);
      }
      else if ('info' === this.dialogType) {
      }

    },
    resetForm(formName) {
      this.$nextTick(() => {
        this.dialogChannelSelect = '';
        this.dialogChannelSelectVal = '';
        this.dialogWhetherGuideSelect = '';
        this.dialogWhetherGuideSelectVal = '';
        this.dialogStatusSelect = 0;
        this.dialogWhetherGuideSelectVal = '';
        this.createTime = [];
        this.carLoanForm = {
          channel: { channelName: '' },
          userInfo: {
            realName: ''
          }
        };
        this.$refs[formName].resetFields();
      })
    },
    checkButtonPermission(perms) {
      let menuPermsList = sessionStorage.getItem("menuPermsList");
      if (menuPermsList.indexOf(perms) != -1) {
        return true
      } else {
        return false;
      }
    }
  },
}
</script>

<style scoped>
.span_hide {
  overflow: hidden;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  height: 24px;
  display: block;
}

.span_hide:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/advance-order/carLoanList.vue